module.exports = __webpack_public_path__ + "img/research_iton_3.b3c08944.png";